module.exports = __webpack_public_path__ + "static/media/icon-upload.4fd34444.svg";